import { markInvoicesPrinted } from '../service/client'
import generateInvoicePdf from './generateInvoicePdf'

export default function generateInvoicesPdf(prepObjs, user) {
  return import('jspdf').then(jsPDF => {
    return import('jspdf-autotable').then(() => {
      const invoiceIds = prepObjs.map(i => i.id).join(', ')
      const doc = jsPDF.jsPDF('portrait')

      prepObjs.forEach((obj, idx) => {
        generateInvoicePdf(obj, doc, idx === prepObjs.length -1)
      });
      
      doc.autoPrint()
      doc.output('dataurlnewwindow')

      return markInvoicesPrinted(user, invoiceIds)
    })
  })
}